import { Button,  
    Col, Container, Row } from 'reactstrap';

const Footer = () =>{
    return(<>
    <section className='bg-dark mt-5'>
        <br/><br/><br/><br/><br/>
        <Container>
            <Row className='d-flex justify-content-center'>
                <Col lg={10} md={10} sm={12}>
                    <Row className='text-center text-white mt-5 mb-5'>
                        <h1>Have Questions? Reach Out!</h1>
                    </Row>
                    <Row className='mb-5'>
                        <Col className='d-flex justify-content-center mt-3' lg={4} md={4} sm={12}>
                            <a href="tel:+19259688172" style={{width:'100%', fontWeight:'bold'}} className='btn btn-light'>Call</a>
                        </Col>
                        <Col className='d-flex justify-content-center mt-3' lg={4} md={4} sm={12}>
                        <a href="sms:+19259688172?body=Hi%20Sarim!%20I%20had%20questions%20about%20the%20workshop.%20Please%20contact%20me." style={{width:'100%', fontWeight:'bold'}} className='btn btn-light'>Text</a>
                        </Col>
                        <Col className='d-flex justify-content-center mt-3' lg={4} md={4} sm={12}>
                        <a href="mailto:sarimkhan2work@gmail.com" style={{width:'100%', fontWeight:'bold'}} className='btn btn-light'>Email</a>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
        <br/><br/><br/><br/><br/>
    </section>
    </>)
}

export default Footer;